import * as Sentry from "@sentry/react";

export const updateUserCardStatus = (hasCard) => {
  try {
    let user = localStorage.getItem("wemoovezUserProfile");
    if (!user) return;
    user = JSON.parse(user);
    user = { ...user, hasCard };
    localStorage.setItem("wemoovezUserProfile", JSON.stringify(user));
  } catch (error) {
    Sentry.captureException(error);
    console.log(error);
  }
};

export const generateBookingLogs = (name, value, temp, triggeredBy, type) => {
  const log = type + "Log";
  let logFile = localStorage.getItem(log);
  const newEntry = { name, value, temp, triggeredBy };
  if (logFile) {
    logFile = JSON.parse(logFile);
    if (Array.isArray(logFile) && logFile.length < 200)
      localStorage.setItem(log, JSON.stringify([...logFile, newEntry]));
    else localStorage.setItem(log, JSON.stringify([newEntry]));
  } else {
    localStorage.setItem(log, JSON.stringify([newEntry]));
  }
};

export const sanitizePersonName = (value) => {
  if (!value) return "";
  return String(value).replace(/[^a-zA-Z\s]/g, "");
};

export const isValidPersonName = (name) => {
  const trimmed = String(name ?? "").trim();
  if (trimmed.length < 2) return false;
  if (!/^[a-zA-Z]+(?:\s+[a-zA-Z]+)*$/.test(trimmed)) return false;
  return trimmed.replace(/\s/g, "").length >= 2;
};

export const getPhoneDigits = (value) =>
  String(value ?? "").replace(/\D/g, "");

export const isValidPhone10Digits = (value) =>
  getPhoneDigits(value).length === 10;

export const formatPhoneDigits = (digits) => {
  const d = String(digits ?? "").replace(/\D/g, "").slice(0, 10);
  if (d.length <= 3) return d;
  if (d.length <= 6) return `${d.slice(0, 3)}-${d.slice(3)}`;
  return `${d.slice(0, 3)}-${d.slice(3, 6)}-${d.slice(6)}`;
};

export const hasLocationAddress = (value) =>
  typeof value === "string" && value.trim() !== "";

export const validateContactInfo = ({
  pickupLocation,
  pickUpPersonName,
  pickUpPersonPhone,
  dropoffLocation,
  dropOffPersonName,
  dropOffPersonPhone,
  stops = [],
}) => {
  const errors = {
    pickUpPersonName: false,
    pickUpPersonPhone: false,
    dropOffPersonName: false,
    dropOffPersonPhone: false,
    stops: {},
  };

  if (hasLocationAddress(pickupLocation)) {
    if (!isValidPersonName(pickUpPersonName)) errors.pickUpPersonName = true;
    if (!isValidPhone10Digits(pickUpPersonPhone)) errors.pickUpPersonPhone = true;
  }

  if (hasLocationAddress(dropoffLocation)) {
    if (!isValidPersonName(dropOffPersonName)) errors.dropOffPersonName = true;
    if (!isValidPhone10Digits(dropOffPersonPhone)) errors.dropOffPersonPhone = true;
  }

  (stops || []).forEach((stop, index) => {
    if (!hasLocationAddress(stop?.stop)) return;

    const stopErrors = { personName: false, personPhone: false };
    if (!isValidPersonName(stop?.personName)) stopErrors.personName = true;
    if (!isValidPhone10Digits(stop?.personPhone)) stopErrors.personPhone = true;

    if (stopErrors.personName || stopErrors.personPhone) {
      errors.stops[index] = stopErrors;
    }
  });

  const isValid =
    !errors.pickUpPersonName &&
    !errors.pickUpPersonPhone &&
    !errors.dropOffPersonName &&
    !errors.dropOffPersonPhone &&
    Object.keys(errors.stops).length === 0;

  return { isValid, errors };
};

export const handleContactPhoneNumber = (e, setphoneNo) => {
  try {
    const digits = getPhoneDigits(e?.target?.value).slice(0, 10);
    setphoneNo(formatPhoneDigits(digits));
  } catch (error) {
    Sentry.captureException(error);
    console.log(error);
  }
};

export const handleValidatePhoneNumber = (e, setphoneNo) => {
  try {
    let number = e?.target?.value;
    let numArr = [...number];
    if (numArr?.length < 13) {
      let newNum = "";
      for (let i = 0; i < numArr?.length; i++) {
        if (numArr[i] >= "0" && numArr[i] <= "9") {
          newNum = `${newNum}${i == 3 || i == 7 ? "-" : ""}${numArr[i]}`;
        } else if (numArr[i] === "-" && (i === 3 || i === 7)) {
          newNum = newNum + numArr[i];
        } else {
          setphoneNo(newNum);
          return null;
        }
      }
      setphoneNo(newNum);
    }
  } catch (error) {
    Sentry.captureException(error);
    console.log(error);
  }
};

export const clearVboAndLogs = () => {
  localStorage.removeItem("VBO");
  localStorage.removeItem("VBOLog");
};

export const clearBookingsFromLocalStorage = () => {
  localStorage.removeItem(`visionVehicle`);
  localStorage.removeItem(`confirm1mover`);
  clearVboAndLogs();
  localStorage.removeItem("loginBooking");
};
